module.exports = __webpack_public_path__ + "img/icon_gyri_inventory.c181ccb.png";